/**
 * Mirrors the server's upload limits in `apps/api/src/services/storage.ts` so the
 * requirements panel states the same rules the API enforces. Kept in one place
 * rather than written into copy, because a mismatch here reads as a bug to the
 * company filling in the form.
 */
export const MAX_UPLOAD_MB = 25
export const MAX_FILES_PER_CYCLE = 20
export const ACCEPTED_UPLOAD_LABEL = 'PDF, Excel (.xlsx), Word (.docx), CSV, images'
